module.exports = __webpack_public_path__ + "img/2.8984d4f0.png";